<template>
 	<mainHeader :isMobile="isMobile" :screenWidth="screenWidth" />
</template>

<script>
import mainHeader from '@/components/home/mainHeader.vue'
export default {
  name: 'homeMain',
  components: { mainHeader },
  props: {
      'isMobile': Boolean,
      'screenWidth': Number
  },
  created() {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>